import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow } from "vue"

const _hoisted_1 = ["aria-expanded", "aria-controls"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["name", "value"]
const _hoisted_4 = { class: "column-sort__label" }

import { computed, ref, onMounted, onUnmounted, watch } from "vue";
import { useSearch } from "@/services/search-service";
import { useStore } from "@/stores/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'ColumnSort',
  props: {
    radioName: {}
  },
  setup(__props: any) {

const store = useStore();
const { sortSearchResult } = useSearch();

const props = __props;

const isOpen = ref(false);
const menuId = computed(() => `${props.radioName}-menu`);
const dropdownRef = ref<HTMLElement | null>(null);
const selectedKey = ref<string | null>(store.sorting.dataKey ?? null);

const sortOptions = [
  { key: "name", label: "Namn", ascending: true },
  { key: "navalBattles", label: "Sjöslag", ascending: true },
  { key: "type", label: "Typ", ascending: true },
  { key: "suspension", label: "Avslut", ascending: false },
  { key: "length", label: "Storlek", ascending: false },
];

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const applySort = () => {
  if (!selectedKey.value) {
    return;
  }
  const option = sortOptions.find((item) => item.key === selectedKey.value);
  const ascending = option ? option.ascending : true;
  store.sorting.dataKey = selectedKey.value;
  store.sorting.descending = !ascending;
  sortSearchResult(selectedKey.value, ascending);
  store.currentPage = 0;
  /* isOpen.value = false; */
};

watch(
  () => store.sorting.dataKey,
  (newKey) => {
    selectedKey.value = newKey ?? null;
  },
);

const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as Node | null;
  if (target && dropdownRef.value && !dropdownRef.value.contains(target)) {
    isOpen.value = false;
  }
};

const handleEscape = (event: KeyboardEvent) => {
  if (event.key === "Escape") {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside, true);
  document.addEventListener("keydown", handleEscape);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside, true);
  document.removeEventListener("keydown", handleEscape);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "column-sort",
    ref_key: "dropdownRef",
    ref: dropdownRef
  }, [
    _createElementVNode("button", {
      class: "button button--filter column-sort__toggle",
      type: "button",
      "aria-expanded": isOpen.value,
      "aria-controls": menuId.value,
      onClick: toggleDropdown
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("span", null, "Sortera efter", -1 /* HOISTED */)),
      _createElementVNode("span", {
        class: _normalizeClass(["column-sort__icon icon icon--arrow-down", { 'column-sort__icon--open': isOpen.value }]),
        "aria-hidden": "true"
      }, null, 2 /* CLASS */)
    ], 8 /* PROPS */, _hoisted_1),
    _withDirectives(_createElementVNode("div", {
      id: menuId.value,
      class: "column-sort__menu"
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortOptions, (option) => {
        return _createElementVNode("label", {
          class: "column-sort__option",
          key: option.key
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: _ctx.radioName,
            value: option.key,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedKey).value = $event)),
            onChange: applySort
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3), [
            [_vModelRadio, selectedKey.value]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "icon icon--radiounchecked" }, null, -1 /* HOISTED */)),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "icon icon--radiochecked" }, null, -1 /* HOISTED */)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(option.label), 1 /* TEXT */)
        ])
      }), 64 /* STABLE_FRAGMENT */))
    ], 8 /* PROPS */, _hoisted_2), [
      [_vShow, isOpen.value]
    ])
  ], 512 /* NEED_PATCH */))
}
}

})